import { render, staticRenderFns } from "./PayPassword.vue?vue&type=template&id=1ca8ae74&scoped=true&"
import script from "./PayPassword.vue?vue&type=script&lang=js&"
export * from "./PayPassword.vue?vue&type=script&lang=js&"
import style0 from "../../less/oinPay.less?vue&type=style&index=0&id=1ca8ae74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8ae74",
  null
  
)

export default component.exports